export default "__VITE_ASSET__Bn_7e$c9__"